module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Region Type:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.regionTypes,
      "label": "Type",
      "rules": _vm.typeRules,
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckTypes()
      }
    },
    model: {
      value: (_vm.regionType),
      callback: function($$v) {
        _vm.regionType = $$v
      },
      expression: "regionType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Region Link:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.regionParents,
      "label": "Link Under",
      "required": "",
      "rules": _vm.linkRules,
      "autocomplete": "",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.regionLink),
      callback: function($$v) {
        _vm.regionLink = $$v
      },
      expression: "regionLink"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Region Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Region Name",
      "single-line": "",
      "required": "",
      "rules": _vm.nameRules,
      "solo": ""
    },
    model: {
      value: (_vm.regionName),
      callback: function($$v) {
        _vm.regionName = $$v
      },
      expression: "regionName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Region Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Region Description",
      "rules": _vm.descriptionRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.regionDescription),
      callback: function($$v) {
        _vm.regionDescription = $$v
      },
      expression: "regionDescription"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isAddValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddRegion()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed.")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}